import { render, staticRenderFns } from "./ModalRemoveItem.vue?vue&type=template&id=ecd5dfea&scoped=true"
import script from "./ModalRemoveItem.vue?vue&type=script&lang=js"
export * from "./ModalRemoveItem.vue?vue&type=script&lang=js"
import style0 from "./ModalRemoveItem.vue?vue&type=style&index=0&id=ecd5dfea&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd5dfea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecd5dfea')) {
      api.createRecord('ecd5dfea', component.options)
    } else {
      api.reload('ecd5dfea', component.options)
    }
    module.hot.accept("./ModalRemoveItem.vue?vue&type=template&id=ecd5dfea&scoped=true", function () {
      api.rerender('ecd5dfea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalRemoveItem.vue"
export default component.exports